import { IconButton_IconSizes, IconButtonSize } from '@ydistri/ds';
import React, { useMemo } from 'react';
import { ImTruck } from 'react-icons/im';
import { FaTruckMedical } from 'react-icons/fa6';
import CalculationAction from './CalculationAction';

interface ProductionCalculationsActionProps {
  disabled?: boolean;
  loading?: boolean;
  tooltip: string;
  value: boolean;
  onClick: () => void;
  size?: IconButtonSize;
}

const ProductionCalculationsAction: React.FC<ProductionCalculationsActionProps> = ({
  value,
  size = 'normal',
  ...rest
}) => {
  const iconHide = useMemo(() => <FaTruckMedical size={IconButton_IconSizes[size]} />, [size]);
  const iconShow = useMemo(() => <ImTruck size={IconButton_IconSizes[size]} />, [size]);

  return (
    <CalculationAction
      size={size}
      icon={value ? iconHide : iconShow}
      tooltipPosition="left"
      checked={value}
      {...rest}
    />
  );
};

export default ProductionCalculationsAction;
